// extracted by mini-css-extract-plugin
export default {"filterMenu":"FilterMenu-filterMenu-vFvai Menu-menu-Uz3_0"};